import { FootballOrganizer } from "../../../commons/models/football/football-organizer";
import { AbstractBaseService } from "../../../ensue-react-system/utilities/base-service";

export interface IFootballOrganizerDTO {
  name: string;
  email: string | null;
  logo: string | null;
  country: string | null;
  website: string | null;
}

export class ManageFootballOrganizerService extends AbstractBaseService<FootballOrganizer> {
  protected __model: FootballOrganizer = new FootballOrganizer();

  public getResourceName(): string {
    return "manage/football/organizers";
  }

  public addOrganizer(organizerData: IFootballOrganizerDTO) {
    return this.__client.post(this.__url, organizerData);
  }

  public editOrganizer(organizerId: number, organizerData: IFootballOrganizerDTO) {
    return this.__client.patch(this.__url + "/" + organizerId, organizerData);
  }
}
